import { Sparkles, Brain, ShieldQuestion } from "lucide-react";

const REASON_META = {
  general: {
    label: "Wants coaching",
    color: "#4A5D4E",
    bg: "#E8EEE9",
    border: "#C5D2C8",
    Icon: Sparkles,
  },
  onboarding_recommendation: {
    label: "Wants coaching",
    color: "#4A5D4E",
    bg: "#E8EEE9",
    border: "#C5D2C8",
    Icon: Sparkles,
  },
  brain_type_consultation: {
    label: "Wants brain-type consult",
    color: "#9C6A53",
    bg: "#F5EAE2",
    border: "#E5D2C2",
    Icon: Brain,
  },
  brain_type_double_check: {
    label: "Wants brain-type double-check",
    color: "#B37A5F",
    bg: "#F5EAE2",
    border: "#E5D2C2",
    Icon: ShieldQuestion,
  },
};

/**
 * Aggregates pending coaching requests into compact badges (one per unique
 * reason) so a coach can glance at their client list and spot who wants what.
 */
export default function ClientRequestBadges({ pendingRequests, size = "md", testid }) {
  if (!pendingRequests || pendingRequests.length === 0) return null;

  // De-duplicate by reason; keep earliest created_at for tooltip
  const byReason = new Map();
  for (const r of pendingRequests) {
    const key = r.reason || "general";
    const existing = byReason.get(key);
    if (!existing || (r.created_at && r.created_at < existing.created_at)) {
      byReason.set(key, r);
    }
  }

  const padding = size === "sm" ? "px-2 py-0.5" : "px-2.5 py-1";
  const text = size === "sm" ? "text-[9px]" : "text-[10px]";
  const iconSize = size === "sm" ? 10 : 12;

  return (
    <div
      className="inline-flex flex-wrap gap-1"
      data-testid={testid || "client-request-badges"}
    >
      {Array.from(byReason.entries()).map(([reason, req]) => {
        const meta = REASON_META[reason] || REASON_META.general;
        const Icon = meta.Icon;
        const created = req.created_at ? new Date(req.created_at).toLocaleDateString() : "";
        return (
          <span
            key={reason}
            data-testid={`request-badge-${reason}`}
            title={`Requested ${created}`}
            className={`inline-flex items-center gap-1 ${padding} rounded-full ${text} font-bold uppercase tracking-[0.12em] border`}
            style={{
              color: meta.color,
              backgroundColor: meta.bg,
              borderColor: meta.border,
            }}
          >
            <Icon strokeWidth={2} size={iconSize} />
            {meta.label}
          </span>
        );
      })}
    </div>
  );
}
